export default __webpack_public_path__ + "static/media/windsock.f2f33c34.svg";